import { Skeleton } from '@chakra-ui/react';

const Loading = () => {
    return (
        <>
            <Skeleton
                css={{
                    '@media only screen and (min-width: 950px)': {
                        display: 'flex',
                    },
                    '@media only screen and (max-width: 920px)': {
                        display: 'none',
                    },
                    '@media only screen and (max-height: 450px)': {
                        height: '250px',
                    },
                }}
                border='1px solid #E2E8F0'
                h='347px'
                p='20px'
                w='100%'
                borderRadius='4px'
            />

            <Skeleton
                h={{ base: 'calc(100vh - 200px)', sm: 'calc(100vh - 80px)' }}
                display='none'
                css={{
                    '@media only screen and (max-width: 920px)': {
                        display: 'block',
                    },

                    '@media only screen and (max-width: 376px)': {
                        padding: '20px 10px',
                    },
                    '@media only screen and (min-width: 380px)': {
                        padding: '60px 10px',
                    },
                    '@media only screen and (max-height: 450px)': {
                        height: '170vh',
                    },
                }}
                w='100%'
                mt={{ base: '70px', sm: '0px' }}
                bg='#F3EEFF'
                mb={{ base: '100px', sm: '0px' }}
                borderRadius={{ base: '28px', sm: '0px' }}
            />
        </>
    );
};

export default Loading;
